// AUTO-GENERATED by scripts/generate-manifest.ts — do not edit by hand.
import type { Project } from '../data/projectMeta';

export const projects: Project[] = [
  {
    "slug": "age-tool",
    "title": "Age Calculator",
    "description": "Exact calendar age in years/months/days with totals, zodiac, and next-birthday countdown.",
    "category": "Time & Date",
    "tags": [
      "date",
      "time",
      "zodiac"
    ],
    "hasIndex": true
  },
  {
    "slug": "ascii-art-tool",
    "title": "ASCII Art Generator",
    "description": "Turn text into ASCII art banners using figlet-style fonts.",
    "category": "Generator",
    "tags": [
      "text",
      "art",
      "generator"
    ],
    "hasIndex": true
  },
  {
    "slug": "aspect-ratio-tool",
    "title": "Aspect Ratio Tool",
    "description": "Compute matching dimensions for a target aspect ratio.",
    "category": "CSS",
    "tags": [
      "css",
      "layout",
      "image"
    ],
    "hasIndex": true
  },
  {
    "slug": "base32-tool",
    "title": "Base32 Tool",
    "description": "Encode and decode Base32 strings.",
    "category": "Crypto & Encoding",
    "tags": [
      "encoding",
      "base32"
    ],
    "hasIndex": true
  },
  {
    "slug": "base64-tool",
    "title": "Base64 Tool",
    "description": "Encode and decode Base64 strings and files.",
    "category": "Crypto & Encoding",
    "tags": [
      "encoding",
      "base64"
    ],
    "hasIndex": true
  },
  {
    "slug": "bmi-tool",
    "title": "BMI Calculator",
    "description": "Body Mass Index calculator with metric and imperial units.",
    "category": "Calculator",
    "tags": [
      "health",
      "fitness"
    ],
    "hasIndex": true
  },
  {
    "slug": "border-radius-tool",
    "title": "Border Radius Tool",
    "description": "Visual box-border-radius generator with copyable CSS.",
    "category": "CSS",
    "tags": [
      "css",
      "layout"
    ],
    "hasIndex": true
  },
  {
    "slug": "bpm-tool",
    "title": "BPM Tool",
    "description": "Tap-tempo BPM counter with delay-time table.",
    "category": "Time & Date",
    "tags": [
      "music",
      "time",
      "audio"
    ],
    "hasIndex": true
  },
  {
    "slug": "braille-tool",
    "title": "Braille Translator",
    "description": "Translate text to and from Braille.",
    "category": "Converter",
    "tags": [
      "accessibility",
      "text",
      "translator"
    ],
    "hasIndex": true
  },
  {
    "slug": "breakout-game",
    "title": "Breakout",
    "description": "Classic brick-breaker with momentum combo scoring.",
    "category": "Game",
    "tags": [
      "arcade",
      "canvas"
    ],
    "hasIndex": true
  },
  {
    "slug": "byte-tool",
    "title": "Data Size Converter",
    "description": "Convert between bytes, KB, MB, GB, and more.",
    "category": "Converter",
    "tags": [
      "units",
      "data"
    ],
    "hasIndex": true
  },
  {
    "slug": "calculator-tool",
    "title": "Calculator",
    "description": "Expression calculator with functions, history, and deg/rad modes.",
    "category": "Calculator",
    "tags": [
      "math",
      "arithmetic"
    ],
    "hasIndex": true
  },
  {
    "slug": "case-tool",
    "title": "Case Converter",
    "description": "Convert text between upper, lower, title, camel, snake, and kebab case.",
    "category": "Converter",
    "tags": [
      "text",
      "formatting"
    ],
    "hasIndex": true
  },
  {
    "slug": "chmod-tool",
    "title": "Chmod Calculator",
    "description": "Compute Unix chmod permissions from symbolic or numeric input.",
    "category": "Calculator",
    "tags": [
      "linux",
      "permissions",
      "unix"
    ],
    "hasIndex": true
  },
  {
    "slug": "cipher-tool",
    "title": "Cipher Tool",
    "description": "Encrypt and decrypt text with classic ciphers.",
    "category": "Crypto & Encoding",
    "tags": [
      "crypto",
      "encryption"
    ],
    "hasIndex": true
  },
  {
    "slug": "clock-dashboard",
    "title": "Clock Dashboard",
    "description": "Live world clock dashboard.",
    "category": "Time & Date",
    "tags": [
      "time",
      "world-clock"
    ],
    "hasIndex": true
  },
  {
    "slug": "color-picker",
    "title": "Color Picker & Palette Builder",
    "description": "Pick colors and build reusable palettes.",
    "category": "CSS",
    "tags": [
      "css",
      "design",
      "color"
    ],
    "hasIndex": true
  },
  {
    "slug": "color-tools",
    "title": "Color Tools",
    "description": "Suite of color utilities: convert, blend, and inspect colors.",
    "category": "CSS",
    "tags": [
      "css",
      "design",
      "color"
    ],
    "hasIndex": true
  },
  {
    "slug": "compound-interest-tool",
    "title": "Compound Interest Calculator",
    "description": "Project compound interest growth with contributions and a yearly breakdown.",
    "category": "Calculator",
    "tags": [
      "finance",
      "money"
    ],
    "hasIndex": true
  },
  {
    "slug": "countdown-tool",
    "title": "Countdown Timer",
    "description": "Countdown timer to a target date with presets.",
    "category": "Time & Date",
    "tags": [
      "time",
      "timer"
    ],
    "hasIndex": true
  },
  {
    "slug": "cron-tool",
    "title": "Cron Expression Tool",
    "description": "Build, parse, and explain cron schedule expressions.",
    "category": "Time & Date",
    "tags": [
      "time",
      "scheduling",
      "devops"
    ],
    "hasIndex": true
  },
  {
    "slug": "css-filter-tool",
    "title": "CSS Filter Tool",
    "description": "Visual CSS filter generator with copyable CSS.",
    "category": "CSS",
    "tags": [
      "css",
      "image"
    ],
    "hasIndex": true
  },
  {
    "slug": "data-url-tool",
    "title": "Data URL Tool",
    "description": "Convert files to and from data URLs.",
    "category": "Crypto & Encoding",
    "tags": [
      "encoding",
      "data-url",
      "base64"
    ],
    "hasIndex": true
  },
  {
    "slug": "diff-tool",
    "title": "Diff Tool",
    "description": "Compare two text blocks and highlight line differences.",
    "category": "Text",
    "tags": [
      "text",
      "compare",
      "dev"
    ],
    "hasIndex": true
  },
  {
    "slug": "duration-tool",
    "title": "Duration Tool",
    "description": "Add, subtract, and format time durations.",
    "category": "Time & Date",
    "tags": [
      "time",
      "formatting"
    ],
    "hasIndex": true
  },
  {
    "slug": "flexbox-tool",
    "title": "CSS Flexbox Generator",
    "description": "Visual flexbox layout builder with copyable CSS.",
    "category": "CSS",
    "tags": [
      "css",
      "layout"
    ],
    "hasIndex": true
  },
  {
    "slug": "game-2048",
    "title": "2048",
    "description": "Slide and merge tiles to reach 2048.",
    "category": "Game",
    "tags": [
      "puzzle",
      "grid"
    ],
    "hasIndex": true
  },
  {
    "slug": "gradient-tool",
    "title": "CSS Gradient Generator",
    "description": "Build linear and radial gradients with copyable CSS.",
    "category": "CSS",
    "tags": [
      "css",
      "color",
      "design"
    ],
    "hasIndex": true
  },
  {
    "slug": "grid-tool",
    "title": "CSS Grid Generator",
    "description": "Visual CSS grid layout builder with copyable CSS.",
    "category": "CSS",
    "tags": [
      "css",
      "layout"
    ],
    "hasIndex": true
  },
  {
    "slug": "hash-generator",
    "title": "Hash Generator",
    "description": "Generate SHA/MD5 hashes and HMACs from text.",
    "category": "Crypto & Encoding",
    "tags": [
      "crypto",
      "checksum",
      "hash"
    ],
    "hasIndex": true
  },
  {
    "slug": "hmac-tool",
    "title": "HMAC Tool",
    "description": "Compute HMAC signatures with multiple algorithms.",
    "category": "Crypto & Encoding",
    "tags": [
      "crypto",
      "auth",
      "hash"
    ],
    "hasIndex": true
  },
  {
    "slug": "html-entities-tool",
    "title": "HTML Entities Tool",
    "description": "Encode and decode HTML entities.",
    "category": "Crypto & Encoding",
    "tags": [
      "encoding",
      "html",
      "text"
    ],
    "hasIndex": true
  },
  {
    "slug": "http-status-tool",
    "title": "HTTP Status Tool",
    "description": "Searchable HTTP status code reference.",
    "category": "Developer",
    "tags": [
      "http",
      "reference",
      "dev"
    ],
    "hasIndex": true
  },
  {
    "slug": "ip-tool",
    "title": "IP Address Tool",
    "description": "Inspect IPv4/IPv6 addresses, ranges, and CIDR blocks.",
    "category": "Developer",
    "tags": [
      "network",
      "dev"
    ],
    "hasIndex": true
  },
  {
    "slug": "json-formatter",
    "title": "JSON Formatter",
    "description": "Format, minify, and validate JSON.",
    "category": "Converter",
    "tags": [
      "json",
      "dev",
      "formatting"
    ],
    "hasIndex": true
  },
  {
    "slug": "jwt-tool",
    "title": "JWT Tool",
    "description": "Decode and inspect JSON Web Tokens.",
    "category": "Crypto & Encoding",
    "tags": [
      "crypto",
      "auth",
      "jwt",
      "dev"
    ],
    "hasIndex": true
  },
  {
    "slug": "keycode-tool",
    "title": "Keycode Tool",
    "description": "Inspect keyboard events: key, code, keyCode, and modifiers.",
    "category": "Developer",
    "tags": [
      "keyboard",
      "dev",
      "reference"
    ],
    "hasIndex": true
  },
  {
    "slug": "keyframe-tool",
    "title": "CSS Keyframe Animation Builder",
    "description": "Build keyframe animations with copyable CSS.",
    "category": "CSS",
    "tags": [
      "css",
      "animation"
    ],
    "hasIndex": true
  },
  {
    "slug": "loan-tool",
    "title": "Loan Calculator",
    "description": "Loan calculator with amortization schedule.",
    "category": "Calculator",
    "tags": [
      "finance",
      "money"
    ],
    "hasIndex": true
  },
  {
    "slug": "lorem-tool",
    "title": "Lorem Ipsum Generator",
    "description": "Generate placeholder Lorem Ipsum text.",
    "category": "Generator",
    "tags": [
      "text",
      "generator",
      "placeholder"
    ],
    "hasIndex": true
  },
  {
    "slug": "mac-address-tool",
    "title": "MAC Address Tool",
    "description": "Validate, format, and generate MAC addresses.",
    "category": "Crypto & Encoding",
    "tags": [
      "network",
      "encoding"
    ],
    "hasIndex": true
  },
  {
    "slug": "markdown-tool",
    "title": "Markdown Tool",
    "description": "Preview and convert Markdown to HTML.",
    "category": "Text",
    "tags": [
      "markdown",
      "text",
      "html"
    ],
    "hasIndex": true
  },
  {
    "slug": "memory-game",
    "title": "Echo Grid — Memory Game",
    "description": "Calm, modern card-matching memory game with a daily challenge.",
    "category": "Game",
    "tags": [
      "puzzle",
      "cards",
      "daily"
    ],
    "hasIndex": true
  },
  {
    "slug": "minesweeper",
    "title": "Minesweeper",
    "description": "Classic minesweeper with flagging and flood-fill reveal.",
    "category": "Game",
    "tags": [
      "puzzle",
      "grid"
    ],
    "hasIndex": true
  },
  {
    "slug": "morse-tool",
    "title": "Morse Code Translator",
    "description": "Translate text to and from Morse code.",
    "category": "Converter",
    "tags": [
      "encoding",
      "translator",
      "audio"
    ],
    "hasIndex": true
  },
  {
    "slug": "nato-tool",
    "title": "NATO Phonetic Alphabet Tool",
    "description": "Spell text using the NATO phonetic alphabet.",
    "category": "Converter",
    "tags": [
      "encoding",
      "translator",
      "text"
    ],
    "hasIndex": true
  },
  {
    "slug": "number-tool",
    "title": "Number Tool",
    "description": "Convert and format numbers across bases and locales.",
    "category": "Converter",
    "tags": [
      "math",
      "formatting",
      "numbers"
    ],
    "hasIndex": true
  },
  {
    "slug": "pace-tool",
    "title": "Running Pace Calculator",
    "description": "Compute running pace, time, distance, speed, and splits.",
    "category": "Calculator",
    "tags": [
      "fitness",
      "running",
      "time"
    ],
    "hasIndex": true
  },
  {
    "slug": "password-generator",
    "title": "Password Generator",
    "description": "Generate strong, customizable passwords.",
    "category": "Generator",
    "tags": [
      "crypto",
      "security",
      "generator"
    ],
    "hasIndex": true
  },
  {
    "slug": "percentage-tool",
    "title": "Percentage Calculator",
    "description": "Percentage calculator for common percent problems.",
    "category": "Calculator",
    "tags": [
      "math",
      "finance"
    ],
    "hasIndex": true
  },
  {
    "slug": "pomodoro-tool",
    "title": "Pomodoro Timer",
    "description": "Pomodoro timer with work/break cycles and settings.",
    "category": "Time & Date",
    "tags": [
      "time",
      "productivity",
      "timer"
    ],
    "hasIndex": true
  },
  {
    "slug": "qr-tool",
    "title": "QR Code Tool",
    "description": "Generate and decode QR codes.",
    "category": "Generator",
    "tags": [
      "encoding",
      "qr",
      "generator"
    ],
    "hasIndex": true
  },
  {
    "slug": "random-generator",
    "title": "Random Generator",
    "description": "Generate random numbers, strings, and selections.",
    "category": "Generator",
    "tags": [
      "random",
      "generator"
    ],
    "hasIndex": true
  },
  {
    "slug": "random-picker-tool",
    "title": "Random Picker Tool",
    "description": "Pick one or many random items from a list.",
    "category": "Generator",
    "tags": [
      "random",
      "list",
      "generator"
    ],
    "hasIndex": true
  },
  {
    "slug": "regex-tester",
    "title": "Regex Tester",
    "description": "Test and debug regular expressions with live matches.",
    "category": "Developer",
    "tags": [
      "regex",
      "dev",
      "text"
    ],
    "hasIndex": true
  },
  {
    "slug": "shadow-tool",
    "title": "CSS Box Shadow Generator",
    "description": "Visual box-shadow generator with copyable CSS.",
    "category": "CSS",
    "tags": [
      "css",
      "design"
    ],
    "hasIndex": true
  },
  {
    "slug": "sleep-tool",
    "title": "Sleep Cycle Calculator",
    "description": "Compute ideal bedtimes and wake times by sleep cycles.",
    "category": "Time & Date",
    "tags": [
      "time",
      "health",
      "sleep"
    ],
    "hasIndex": true
  },
  {
    "slug": "slug-tool",
    "title": "Slug Tool",
    "description": "Generate URL-friendly slugs from text.",
    "category": "Crypto & Encoding",
    "tags": [
      "encoding",
      "url",
      "text"
    ],
    "hasIndex": true
  },
  {
    "slug": "snake-game",
    "title": "Snake",
    "description": "Classic Snake game.",
    "category": "Game",
    "tags": [
      "arcade",
      "grid"
    ],
    "hasIndex": true
  },
  {
    "slug": "sort-lines-tool",
    "title": "Sort Lines Tool",
    "description": "Sort, dedupe, and transform lists of lines.",
    "category": "Text",
    "tags": [
      "text",
      "list",
      "formatting"
    ],
    "hasIndex": true
  },
  {
    "slug": "specificity-tool",
    "title": "CSS Specificity Calculator",
    "description": "Calculate CSS selector specificity scores.",
    "category": "CSS",
    "tags": [
      "css",
      "dev"
    ],
    "hasIndex": true
  },
  {
    "slug": "stopwatch-tool",
    "title": "Stopwatch",
    "description": "Stopwatch with lap timing and stats.",
    "category": "Time & Date",
    "tags": [
      "time",
      "timer"
    ],
    "hasIndex": true
  },
  {
    "slug": "svg-placeholder-tool",
    "title": "SVG Placeholder Tool",
    "description": "Generate SVG placeholder images in multiple export formats.",
    "category": "CSS",
    "tags": [
      "css",
      "svg",
      "image",
      "generator"
    ],
    "hasIndex": true
  },
  {
    "slug": "tetris-game",
    "title": "Tetris",
    "description": "Classic Tetris with line clears and scoring.",
    "category": "Game",
    "tags": [
      "arcade",
      "puzzle"
    ],
    "hasIndex": true
  },
  {
    "slug": "text-stats-tool",
    "title": "Text Statistics",
    "description": "Count words, characters, sentences, and reading time.",
    "category": "Text",
    "tags": [
      "text",
      "analysis",
      "counting"
    ],
    "hasIndex": true
  },
  {
    "slug": "text-tools",
    "title": "Text Tools",
    "description": "Suite of text utilities: transform, count, and inspect text.",
    "category": "Text",
    "tags": [
      "text",
      "formatting"
    ],
    "hasIndex": true
  },
  {
    "slug": "timestamp-tool",
    "title": "Timestamp Tool",
    "description": "Convert between Unix timestamps and human-readable dates.",
    "category": "Time & Date",
    "tags": [
      "time",
      "date",
      "unix",
      "dev"
    ],
    "hasIndex": true
  },
  {
    "slug": "tip-tool",
    "title": "Bill & Tip Calculator",
    "description": "Split a bill and calculate tips per person.",
    "category": "Calculator",
    "tags": [
      "finance",
      "money"
    ],
    "hasIndex": true
  },
  {
    "slug": "toml-tool",
    "title": "TOML / JSON / YAML Converter",
    "description": "Convert between TOML, JSON, and YAML.",
    "category": "Converter",
    "tags": [
      "converter",
      "config",
      "dev"
    ],
    "hasIndex": true
  },
  {
    "slug": "unicode-tool",
    "title": "Unicode Inspector",
    "description": "Inspect code points, names, and properties of text.",
    "category": "Crypto & Encoding",
    "tags": [
      "encoding",
      "unicode",
      "text"
    ],
    "hasIndex": true
  },
  {
    "slug": "unit-converter",
    "title": "Unit Converter",
    "description": "Convert between length, weight, temperature, and more.",
    "category": "Converter",
    "tags": [
      "units",
      "converter",
      "science"
    ],
    "hasIndex": true
  },
  {
    "slug": "url-tool",
    "title": "URL Tool",
    "description": "Parse, encode, and decode URLs and query strings.",
    "category": "Crypto & Encoding",
    "tags": [
      "encoding",
      "url",
      "dev"
    ],
    "hasIndex": true
  },
  {
    "slug": "uuid-generator",
    "title": "UUID Generator",
    "description": "Generate UUIDs in multiple versions and formats.",
    "category": "Generator",
    "tags": [
      "crypto",
      "uuid",
      "generator",
      "dev"
    ],
    "hasIndex": true
  },
  {
    "slug": "vat-tool",
    "title": "VAT Calculator",
    "description": "VAT calculator for net, gross, and rate from any two values.",
    "category": "Calculator",
    "tags": [
      "finance",
      "tax",
      "money"
    ],
    "hasIndex": true
  },
  {
    "slug": "xml-tool",
    "title": "XML / JSON Converter",
    "description": "Convert between XML and JSON.",
    "category": "Converter",
    "tags": [
      "converter",
      "config",
      "dev"
    ],
    "hasIndex": true
  }
];

